// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const USER_LOGOUT = 'USER_LOGOUT';

export const logoutUser = () => ({
  type: USER_LOGOUT
});
